import { useQuery } from '@tanstack/react-query';

export const useVictoriaEnabledQuery = ({ isAuthenticated, user }) =>
    useQuery({
        queryKey: ['victoria-enabled', user?.email],
        enabled: isAuthenticated && Boolean(user?.bearer),
        staleTime: 0,
        queryFn: async () => {
            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/victoria-enabled`, {
                    headers: {
                        Authorization: `Bearer ${user.bearer}`,
                        Accept: 'application/json',
                    },
                });

                if (!response.ok) return false;

                const data = await response.json();
                return data.victoria === true;
            } catch (error) {
                console.error('Error checking Victoria feature flag:', error);
                return false;
            }
        },
    });
